import { put, race, take, takeLatest } from 'redux-saga/effects';

import * as confirmlVisit from '../requests/confirm-visit-by-patient-req';
import * as success from '../../ui/success';
import * as error from '../../ui/error';

export function* confirmVisitByPatientSagaWorker({ payload }) {
  yield put(confirmlVisit.actions.send(payload));

  const { succeed, failed } = yield race({
    succeed: take(confirmlVisit.actions.succeed),
    failed: take([
      confirmlVisit.actions.rejected,
      confirmlVisit.actions.errorEncountered,
    ]),
  });

  if (succeed) {
    yield put({
      type: success.consts.UPDATE,
      payload: { id: 'appointment.visitConfirmed' },
    });
  }

  if (failed) {
    yield put({
      type: error.consts.UPDATE,
      payload: { id: 'errors.common' },
    });
  }
}

export default function* confirmVisitByPatientSaga() {
  yield takeLatest(confirmlVisit.actions.init, confirmVisitByPatientSagaWorker);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/confirm-visit-by-patient.js